import UltMeta, { Meta } from "./UltMeta/index";

class App extends UltMeta {
    THREE_TERMINAL = new Meta(1, "三端");
    CARRYING_AGREEMENT = new Meta(2, "承运端");
    PC_WEB = new Meta(3, "志豪链云 PC 端");
}

export const APP = new App();

class Type extends UltMeta {
    ABOUT_US = new Meta(1, "关于我们");
    USER_AGREEMENT = new Meta(2, "用户协议");
    PRIVACY_AGREEMENT = new Meta(3, "隐私协议");
    MEMBER_AGREEMENT = new Meta(4, "会员服务协议");
    DEVICE_CLAIM_AGREEMENT = new Meta(5, "认领协议");
    INFO_SERVICE_AGREEMENT = new Meta(6, "信息服务协议");
    CONTACT_US = new Meta(7, "联系我们");
    AI_USER_AGREEMENT = new Meta(8, "智能助理用户协议");
    AI_PRIVACY_AGREEMENT = new Meta(9, "智能助理保护规则");
    REFUELING_AGREEMENT = new Meta(10, "加油协议");
    CARRIER_AUTH_AGREEMENT = new Meta(11, "船运合同服务协议");
}

export const TYPE = new Type();
